import { get, post, patch, del, postNoBody, apiClient } from './client';
import {
  DashboardListResponseSchema,
  DashboardSummarySchema,
  DashboardDetailSchema,
  WidgetRowSchema,
  SqlValidateResponseSchema,
  SqlPreviewResponseSchema,
} from './schemas';
import type { LayoutItem } from './schemas';

export interface CreateWidgetRequest {
  title:       string;
  sql?:        string;
  chart_type?: string;
  col_width?:  number;
  x_col?:      string | null;
  y_col?:      string | null;
  widget_key?: string;
  x?:          number;
  y?:          number;
  w?:          number;
  h?:          number;
  options?:    Record<string, unknown> | null;
}

export interface UpdateWidgetRequest {
  title?:      string;
  sql?:        string;
  chart_type?: string;
  col_width?:  number;
  x_col?:      string | null;
  y_col?:      string | null;
  widget_key?: string;
  x?:          number;
  y?:          number;
  w?:          number;
  h?:          number;
  options?:    Record<string, unknown> | null;
}

export const dashboardsApi = {
  list: () =>
    get('/dashboards', DashboardListResponseSchema),

  create: (name: string) =>
    post('/dashboards', { name }, DashboardSummarySchema),

  getOne: (id: number) =>
    get(`/dashboards/${id}`, DashboardDetailSchema),

  update: (id: number, body: { name?: string; is_published?: boolean }) =>
    patch(`/dashboards/${id}`, body, DashboardDetailSchema),

  delete: (id: number) =>
    del(`/dashboards/${id}`),

  createWidget: (id: number, body: CreateWidgetRequest) =>
    post(`/dashboards/${id}/widgets`, body, WidgetRowSchema),

  updateWidget: (id: number, wid: number, body: UpdateWidgetRequest) =>
    patch(`/dashboards/${id}/widgets/${wid}`, body, WidgetRowSchema),

  deleteWidget: (id: number, wid: number) =>
    del(`/dashboards/${id}/widgets/${wid}`),

  reorderWidgets: (id: number, order: number[]) =>
    postNoBody(`/dashboards/${id}/widgets/reorder`, { order }),

  updateLayout: async (id: number, items: LayoutItem[]) => {
    await apiClient.put(`/dashboards/${id}/widgets/layout`, { items });
  },

  runWidget: (id: number, wid: number, fund: string, date: string) =>
    get(`/dashboards/${id}/widgets/${wid}/run`, SqlPreviewResponseSchema, {
      params: { fund, date },
    }),

  validateSql: (sql: string) =>
    post('/dashboards/sql/validate', { sql }, SqlValidateResponseSchema),

  previewSql: (sql: string, fund: string, date: string) =>
    post('/dashboards/sql/preview', { sql, fund, date }, SqlPreviewResponseSchema),
};
